<template>
    <div class="kgr-emptyMessage">
        {{ value }}
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true,
        },
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
